import { Outlet, useNavigate } from 'react-router-dom';
import KnowledgeBaseAction from 'components/Shared/KnowledgeBaseAction';
import { SLayoutWrapper, SMainContentWrapper } from './Layout.styles';
import Header from './Header';
import Notifications from './Notifications';
import { useGetIncompleteAnimalsQuery } from 'redux/apiSlice/animal.slice';
import CreateAnimalModal from 'pages/private/Animal/components/CreateAnimal/CreateAnimalModal';
import { useEffect, useRef } from 'react';
import { useAppDispatch, useAppSelector } from 'redux/store';
import appSlice from 'redux/slices/app.slice';
import { PageSpinner } from '../Spinner';

const Layout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const createAnimalModalRef = useRef<{
    open: (id: string, actionType: string, url: string) => void;
  }>({
    open: () => {
      /* do nothing */
    },
  });

  const fromOnboarding = useAppSelector(state => state.appSlice.fromOnboarding);
  const { data: incompleteAnimals, isLoading } = useGetIncompleteAnimalsQuery();

  useEffect(() => {
    if (fromOnboarding) {
      if (incompleteAnimals && incompleteAnimals.count > 0) {
        const { animalId, applicationId, incompleteResource } =
          incompleteAnimals;
        const url = `/app/application/application-complete/${applicationId}`;

        if (incompleteResource === 'ANIMAL') {
          createAnimalModalRef.current.open(
            animalId,
            'complete',
            applicationId ? url : '',
          );
          dispatch(
            appSlice.actions.setViewApplicationProps({
              animalId,
            }),
          );
        } else if (applicationId) {
          dispatch(
            appSlice.actions.setViewApplicationProps({
              animalId,
            }),
          );
          navigate(url);
        }
        // Reset the flag after onboarding
        dispatch(appSlice.actions.setFromOnboarding(false));
      }
    }
  }, [fromOnboarding, incompleteAnimals]);

  return (
    <SLayoutWrapper>
      {isLoading ? (
        <PageSpinner centered />
      ) : (
        <>
          <KnowledgeBaseAction />
          <Header />
          <Notifications />
          <SMainContentWrapper className="container-lg">
            <Outlet />
          </SMainContentWrapper>
          <CreateAnimalModal
            ref={createAnimalModalRef}
            residenceId={incompleteAnimals?.tenantResidencyId}
          />
        </>
      )}
    </SLayoutWrapper>
  );
};

export default Layout;
